import { NavLink } from "react-router-dom";
import { Home, Shirt, MessagesSquare, User } from "lucide-react";
import { IDS } from "@/constants/testIds";

const items = [
  { to: "/home", label: "Home", icon: Home, id: IDS.navHome },
  { to: "/closet", label: "Closet", icon: Shirt, id: IDS.navCloset },
  { to: "/chat", label: "Stylist", icon: MessagesSquare, id: IDS.navChat },
  { to: "/profile", label: "Profile", icon: User, id: IDS.navProfile },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-[#FBF9F6]/85 backdrop-blur-xl border-t border-stone-200/70 lg:border-x lg:border-stone-200/70 z-40">
      <div className="flex justify-around items-center py-3 pb-[max(env(safe-area-inset-bottom),0.75rem)]">
        {items.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={id}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-4 py-1 transition-colors ${
                isActive ? "text-[#6B7A54]" : "text-stone-500"
              }`
            }
          >
            <Icon size={20} strokeWidth={1.5} />
            <span className="text-[10px] font-[Manrope] font-medium tracking-wider uppercase">
              {label}
            </span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
